export enum UserType {
  LOCAL= 'Local',
  FILE_REPOSITORY = 'File Repository',
  LDAP_SERVER = 'LDAP server'
}
